import config from 'config';

export const debugWhitelistedDomains = [
  {
    domain: 'test-development',
    description:
      'Test Business Units here. If an instance has no orgLevels then busines units will not appear.',
  },
  {
    domain: 'test-azure',
    description:
      'Test People Data and SSO here. An instance will display People Data when the People Data feature is enabled and data synced through azure.',
  },
  {
    domain: 'featuretest',
    description:
      'This instance uses foc data. It is another instance of foctest used to test multiple features during a sprint.',
  },
];

export function domainIsWhitelisted() {
  // window.location.host === 'subdomain.domain.com'
  let full = window.location.host;
  let parts = full.split('.');
  let subdomain = parts[0];
  if (subdomain) {
    subdomain.toLowerCase();
  } else {
    return false;
  }

  for (let index in debugWhitelistedDomains) {
    if (debugWhitelistedDomains[index].domain === subdomain) {
      return true;
    }
  }

  return false;
}

export function isDebugEnabled() {
  return config.ENV === 'development' || config.ENV === 'test';
}

export function routeToDebugPage() {
  if (isDebugEnabled() && !window.location.href.includes('/admin/debug')) {
    window.location = '/admin/debug';
  }
}
